import React from 'react'
import CircleRedSvg from '../../assets/icons/CircleRedSvg'
import CircleGreenSvg from '../../assets/icons/CircleGreenSvg'
import { useSelector } from 'react-redux'

const SelectTesis = ({ data, onSelect, selectedItem }) => {
  const user = useSelector((state) => state.user.user)

  return (
    <>
      <div className='selectBahceTitle'>
        <div>
          <div className='title'>{selectedItem?.title || selectedItem?.bahce_adi || selectedItem?.adi || '-'}</div>
          <div className='infoDiv'>
            <div className='infoWrapper'>
              <CircleGreenSvg width={10} height={10} />
              <div className='info'>{`Açılış ${selectedItem?.acilis_saati || '-'}`}</div>
            </div>
            <div className='infoWrapper'>
              <CircleRedSvg width={10} height={10} />
              <div className='info'>{`Kapanış ${selectedItem?.kapanis_saati || '-'}`}</div>
            </div>
          </div>
        </div>
        <div className='parselNoBorder'>
          <div className='parselNoDiv'>
            <div className='parselNoTitle'>Parsel No</div>
            <div className='parselNo'>{user?.parsel_no}</div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SelectTesis
